import { createStore } from 'vuex'

export default createStore({
  state: {
    movementType: null, // Stores 'entry' or 'exit'
    movementId: null,
    detailMovement: {},
  },
  getters: {
    getMovementType: (state) => state.movementType,
    getMovementId: (state) => state.movementId,
    getDetailMovement: (state) => state.detailMovement,
  },
  mutations: {
    setMovementType(state, type) {
      state.movementType = type;
    },
    setMovementId(state, type) {
      state.movementId = type;
    },
    setDetailMovement(state, type) {
      state.detailMovement = type;
    },
  },
  actions: {
  },
  modules: {
  }
})
